(function () {
    'use strict';

    var validateOneCapitalLetter = {
        /*templateUrl: 'app/components/validateOneCapitalLetter/validateOneCapitalLetter.html',*/
        controller: validateOneCapitalLetterController,
        controllerAs: 'vm',
        bindings: {
            ngModel: "="
        }
    }

    angular
        .module('completeAir')
        .component('validateOneCapitalLetter', validateOneCapitalLetter)

    validateOneCapitalLetterController.$inject = ['$element'];

    function validateOneCapitalLetterController($element) {
        var vm = this;
        var input = $element.parent(),
            inputJQ = input.find('.form-control');
        vm.value = "";

        inputJQ.on('blur', function(){
            var ele = $(this),
                val = ele.val();

            if (!isNaN(val) && angular.isNumber(+val)) {
                //vm.baseRate.tradeName = val.replace(/[0-9]/g, "");
                vm.ngModel = val.replace(/[0-9]/g, "");
            } else if(!vm.isValidString(val)){
                //vm.baseRate.tradeName = "";
                vm.ngModel = "";
            }else if(val){
                //vm.baseRate.tradeName = val.toUpperCase();
                vm.ngModel = val.toUpperCase();
            }
        })


        vm.capitalize = function (val) {
            if (!isNaN(val) && angular.isNumber(+val)) {
                //vm.baseRate.tradeName = val.replace(/[0-9]/g, "");
                vm.ngModel = val.replace(/[0-9]/g, "");
            } else if(!vm.isValidString(val)){
                //vm.baseRate.tradeName = "";
                vm.ngModel = "";
            }else if(val){
                //vm.baseRate.tradeName = val.toUpperCase();
                vm.ngModel = val.toUpperCase();
            }
        }

        vm.isValidString = function (str) {
            var iChars = "~`!#$%^&*+=-[]\\\';,/{}|\":<>?";
            if(str){
                for (var i = 0; i < str.length; i++) {
                    if (iChars.indexOf(str.charAt(i)) != -1) {
                        return false;
                    }
                }
            }
            return true;
        }

    }
})();

